import { Alert, Box, Text } from '@zillow/constellation-10';
import type { CpmBoostAdPreviewDto } from '@zg-rentals/rental-manager-env';
import { useIsScreenDesktop } from '@zg-rentals/rental-manager-env';

export interface BoostAdPreviewsProps {
  previews: Array<CpmBoostAdPreviewDto>;
}

const BoostAdPreview = ({ title = '', body, errorMessage }: { title: string; body: string; errorMessage?: string }) => {
  const isScreenDesktop = useIsScreenDesktop();
  const overflowX = isScreenDesktop ? 'auto' : 'scroll';
  // Would be ideal to set the height programmatically, but the iframe document can't be accessed

  const renderBody = () => {
    if (errorMessage) {
      return <Alert tone="critical">{errorMessage}</Alert>;
    }
    const htmlBody = body
      .replace(/height="\d*"/, 'height="690px"')
      .replace(/<iframe(?![^>]*\sheight=)/, '<iframe height="690px"')
      .replace(/scrolling="yes"/, '/scrolling="no"/');
    return <Box css={{ overflowX }} dangerouslySetInnerHTML={{ __html: htmlBody }} />;
  };

  return (
    <Box css={{ paddingBlockStart: '600', paddingBlockEnd: '400' }}>
      <Text textStyle="body-bold">{title.toUpperCase()}</Text>
      {renderBody()}
    </Box>
  );
};

export const BoostAdPreviews = ({ previews = [] }: BoostAdPreviewsProps) => {
  return (
    <div className="BoostAdPreviews">
      {previews.map((preview) => (
        <BoostAdPreview
          key={preview.cpmBoostType}
          title={preview.cpmBoostType}
          body={preview.body}
          errorMessage={preview.errorMessage}
        />
      ))}
    </div>
  );
};
